// DOP-925: API công khai của Tracking SDK — track(eventName, properties).
// Hàm thuần, gọi được từ mọi nơi (component/thunk/util), không cần hook.
// Mọi lỗi đều nuốt im lặng: tracking KHÔNG bao giờ được làm vỡ flow chính.
import { ensureSession, getAnonymousId, getDeviceProperties, getUserId } from "./identity"
import { enqueue } from "./queue"
import { TrackingEvent, TrackingEventName } from "./types"

// Chỉ bật cho web B2C (giống điều kiện gắn GTM/GA ở layout.tsx)
const IS_TRACKING_ENABLED = process.env.NEXT_PUBLIC_WEB === 'B2C'

const buildEvent = (
  eventName: TrackingEventName,
  properties: Record<string, any>,
  sessionId: string,
): TrackingEvent => ({
  event_name: eventName,
  event_time: new Date().toISOString(),
  session_id: sessionId,
  anonymous_id: getAnonymousId(),
  user_id: getUserId(),
  page_url: window.location.href,
  properties,
})

export const track = (eventName: TrackingEventName, properties: Record<string, any> = {}) => {
  try {
    if (typeof window === 'undefined' || !IS_TRACKING_ENABLED) return

    const { sessionId, isNew } = ensureSession()
    if (isNew) {
      // Session mới → tự bắn session_start kèm device info (spec: Session + Device Tracking)
      enqueue(buildEvent('session_start', getDeviceProperties(), sessionId))
    }
    enqueue(buildEvent(eventName, properties, sessionId))
  } catch {
    // silent — tracking không được ảnh hưởng flow người dùng
  }
}
